import React, {lazy} from "react";
import {Route, Routes} from "react-router-dom";

import {retryFailLoad} from "data/utils";
import {NotAuthOnlyRoute} from "views/components/route";

const Home = lazy(retryFailLoad(() => import("views/pages/home/home.page")));
const Backdoor = lazy(retryFailLoad(() => import("views/pages/backdoor/backdoor.page")));
const Help = lazy(retryFailLoad(() => import("views/pages/help/help.page")));
const NotFound = lazy(retryFailLoad(() => import("views/pages/not_found/not_found.page")));
const ContestPlayers = lazy(retryFailLoad(() => import("views/pages/players/players.page")));
const Leaderboard = lazy(retryFailLoad(() => import("views/pages/leaderboard/leaderboard.page")));
const Results = lazy(retryFailLoad(() => import("views/pages/results/results.page")));

export const RootRoutes: React.FC = () => (
	<Routes>
		<Route index path="/" element={<Home />} />
		<Route index path="/results" element={<Results />} />
		<Route path="/contest/:gameFeedId" element={<ContestPlayers />} />
		<Route path="/leaderboard" element={<Leaderboard />} />
		<Route element={<NotAuthOnlyRoute />}>
			<Route path="/backdoor" element={<Backdoor />} />
		</Route>
		<Route path="help/*" element={<Help />} />
		<Route path="*" element={<NotFound />} />
	</Routes>
);

export default RootRoutes;
